export const VERSION = '1.0.0';
export const TOKEN_NAME = 'CheeleeWebToken';

export const EXCHANGE_RATES_COOKIE_NAME = 'chl_exchange_rates';
export type ExchangeRatesCoins = 'lee' | 'cheelee';

export const TEST_VERSION = 'v1';
export const AB_TESTING_COOKIE_NAME = 'ab_testing_group';
export type AbTestingGroup = 'a' | 'b';
